import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FRONTENDURL, USERAPIURL } from "../Constants";

import "./profileSection.css";
import ProfileEvent from "./ProfileEvent";
import Navbar from "./Navbar";
import { toast } from "react-hot-toast";
import Footer from "./Footer";

const ProfileSection = () => {

  const navigate = useNavigate()

  const [texid, setTexid] = useState("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [eventsData, seteventsData] = useState([])

  function login ()
  {
    navigate("/login", { state: { path: FRONTENDURL + 'profile' } })
  }

  useEffect(() => 
  {
    if(localStorage.getItem('userToken'))
    {
      axios.get(USERAPIURL + 'getUser',
      { headers: { "Authorization": `${localStorage.getItem('userToken')}` } })
      .then((res) => {
        setTexid(res.data.currentUser._id)
        setName(res.data.currentUser.name)
        setEmail(res.data.currentUser.email)
        axios.post(USERAPIURL + 'getAllRegisteredEvents', {id: res.data.currentUser._id}).then((response) => {
          seteventsData(response.data.events)
          console.log(response.data.events)
        })
      })
      .catch((err) => {
        localStorage.removeItem('userToken')
            toast.error(err.response.data.error);
            login()
      })
    }
    else
    {
        login()
    }
  }, [])

    const events = eventsData.map((event) => (
      <ProfileEvent
        key={event._id}
        event = {event}
      />
    ));


  return (
    <>
    <Navbar />
    <section className="joining-section">
      <div className="container">
        <div className="col-md-6">
            <p className="profile-subheading mb-3">{texid}</p>
            <h1 className="profile-heading mb-3">{name}</h1>
            <p className="profile-subheading mb-3">{email}</p>
        </div>
        <div className="col-lg-12">
          <h2 className="profile-events-heading mb-5">Events</h2>
          <div className="row">
            {events}
          </div>
        </div>
      </div>
    </section>
    <Footer />
    </>
  );
};
/* test */
export default ProfileSection;
